import React from 'react';
import { motion } from 'framer-motion';
import { Users, GraduationCap, Compass } from 'lucide-react';
const CG_TOOLS = ['Sistemas de Información Geográfica (SIG)', 'Cartografía social', 'Planeación estratégica', 'Formulación de proyectos', 'Veedurías ciudadanas', 'Información catastral para decisiones'];
const CG_MUNICIPALITIES = [{
  name: 'El Dorado',
  dept: 'Meta'
}, {
  name: 'Mapiripán',
  dept: 'Meta',
  tefos: true
}, {
  name: 'Vista Hermosa',
  dept: 'Meta',
  tefos: true
}, {
  name: 'San Juan Nepomuceno',
  dept: 'Bolívar'
}, {
  name: 'Toluviejo',
  dept: 'Sucre'
}, {
  name: 'Mercaderes',
  dept: 'Cauca'
}, {
  name: 'Inzá',
  dept: 'Cauca'
}, {
  name: 'Tumaco',
  dept: 'Nariño'
}, {
  name: 'Puerto Rico',
  dept: 'Caquetá',
  tefos: true
}];
const PARES_STAGES = [{
  icon: Users,
  title: 'Promotores comunitarios',
  description: 'Aprenden qué es el Catastro Multipropósito, sus beneficios y por qué importa la participación. Sirven de enlace entre comunidades e instituciones.'
}, {
  icon: Compass,
  title: 'Auxiliares de campo',
  description: 'Formación especializada en herramientas técnicas y sociales para acompañar la construcción del conocimiento territorial.'
}, {
  icon: GraduationCap,
  title: 'Reconocedores prediales',
  description: 'Fortalecimiento de capacidades para participar directamente en los procesos de reconocimiento predial.'
}];
const MUNICIPALITIES = ['El Retorno', 'San José del Guaviare', 'Calamar', 'Mesetas', 'Vista Hermosa', 'Tierralta', 'Montelíbano', 'San José de Uré', 'Puerto Guzmán', 'Puerto Asís', 'Leguízamo', 'Puerto Rico', 'San Vicente del Caguán', 'Solano'];
export function EscuelaIntercultural() {
  return <section id="hito-2" className="py-24 md:py-32 px-4 md:px-8 bg-bone-dark scroll-mt-24" data-id="element-124">
      <div className="max-w-[1400px] mx-auto" data-id="element-125">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-16 lg:mb-20" data-id="element-126">
          <div className="lg:col-span-5" data-id="element-127">
            <span className="block text-clay uppercase tracking-[0.2em] text-xs font-semibold mb-5" data-id="element-128">
              Hito 02 · Escuelas Interculturales
            </span>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif text-forest leading-[1.05]" data-id="element-129">
              Escuela Intercultural de Geografía para la Vida
            </h2>
          </div>
          <div className="lg:col-span-7 lg:pt-3" data-id="element-130">
            <p className="text-lg md:text-xl text-charcoal/85 font-light leading-relaxed mb-5" data-id="element-131">
              Una alianza del IGAC con la cooperación alemana (GIZ) y el Banco
              Mundial, iniciativa derivada del Plan Nacional de Desarrollo
              2022–2026 y financiada con recursos públicos, que ha fortalecido
              la participación comunitaria en los procesos de formación y
              actualización catastral.
            </p>
            <p className="text-base text-charcoal/70 font-light leading-relaxed" data-id="element-132">
              Trabaja con líderes y lideresas comunitarias, organizaciones
              sociales, autoridades locales, resguardos indígenas, consejos
              comunitarios y juntas de acción comunal — reconociendo las
              diferencias culturales, de género y las particularidades de cada
              territorio. Su propósito es acercar a las comunidades a la
              información catastral multipropósito y fortalecer la relación
              entre las instituciones y la ciudadanía.
            </p>
          </div>
        </div>

        {/* Pares stages */}
        <div className="mb-16 lg:mb-20" data-id="element-133">
          <div className="flex items-end justify-between mb-8" data-id="element-134">
            <h3 className="font-serif text-2xl md:text-3xl text-forest" data-id="element-135">
              Estrategia PAR
            </h3>
            <div className="hidden md:block h-px bg-charcoal/15 flex-grow mx-8" data-id="element-136" />
            <span className="text-xs uppercase tracking-widest text-charcoal/60 font-medium" data-id="element-137">
              Tres etapas
            </span>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-138">
            {PARES_STAGES.map((stage, i) => {
            const Icon = stage.icon;
            return <motion.article key={stage.title} initial={{
              opacity: 0,
              y: 30
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true,
              margin: '-50px'
            }} transition={{
              duration: 0.5,
              delay: i * 0.1
            }} className="bg-bone p-8 border-t-2 border-clay flex flex-col gap-5 h-full" data-id="element-139">
                  <div className="flex items-center justify-between" data-id="element-140">
                    <Icon className="text-forest" size={28} strokeWidth={1.5} data-id="element-141" />
                    <span className="font-serif text-clay text-2xl" data-id="element-142">
                      {String(i + 1).padStart(2, '0')}
                    </span>
                  </div>
                  <h4 className="font-serif text-2xl text-forest leading-tight" data-id="element-143">
                    {stage.title}
                  </h4>
                  <p className="text-charcoal/75 font-light leading-relaxed text-sm" data-id="element-144">
                    {stage.description}
                  </p>
                </motion.article>;
          })}
          </div>
        </div>

        {/* Impact panel */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 lg:grid-cols-12 gap-0 bg-forest text-bone overflow-hidden" data-id="element-145">
          <div className="lg:col-span-5 relative min-h-[320px] lg:min-h-0" data-id="element-146">
            <img src="https://cdn.magicpatterns.com/uploads/jRzAeUhV2UQqKneKD2Tc3v/DSC06728.jpg" alt="Jornada de la Escuela Intercultural de Geografía con comunidades e IGAC" className="absolute inset-0 w-full h-full object-cover" data-id="element-147" />
          </div>
          <div className="lg:col-span-7 p-8 md:p-12 lg:p-14" data-id="element-148">
            <span className="text-clay-light text-xs uppercase tracking-[0.2em] font-semibold" data-id="element-149">
              Implementación a marzo 2025
            </span>
            <h3 className="font-serif text-3xl md:text-4xl mt-4 mb-8 leading-tight" data-id="element-150">
              Resultados en los municipios TEFOS
            </h3>

            <div className="mb-10 pb-10 border-b border-bone/15" data-id="element-151">
              <div className="font-serif text-clay-light text-6xl md:text-7xl leading-none" data-id="element-152">
                +500
              </div>
              <div className="text-bone/70 text-sm mt-3 font-light max-w-md" data-id="element-153">
                Promotores comunitarios y auxiliares de campo capacitados y
                certificados, con potencial de vinculación a las operaciones
                catastrales.
              </div>
            </div>

            <div className="text-xs uppercase tracking-[0.2em] text-bone/60 font-semibold mb-4" data-id="element-154">
              14 municipios TEFOS
            </div>
            <div className="flex flex-wrap gap-2" data-id="element-155">
              {MUNICIPALITIES.map(m => <span key={m} className="border border-bone/25 px-3 py-1.5 text-xs font-medium text-bone/90" data-id="element-156">
                  {m}
                </span>)}
            </div>
          </div>
        </motion.div>

        {/* Perspectivas / futuro */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 lg:grid-cols-12 gap-12 mt-16 lg:mt-20" data-id="element-157">
          <div className="lg:col-span-5" data-id="element-158">
            <span className="block text-clay uppercase tracking-[0.2em] text-xs font-semibold mb-4" data-id="element-159">
              Hacia adelante
            </span>
            <h3 className="font-serif text-2xl md:text-3xl text-forest leading-tight" data-id="element-160">
              Ampliar el alcance y fortalecer la participación
            </h3>
          </div>
          <div className="lg:col-span-7 lg:pt-2 text-charcoal/80 font-light leading-relaxed" data-id="element-161">
            <p data-id="element-162">
              Actualmente, la estrategia del IGAC busca ampliar su alcance con
              nuevos módulos de formación para reconocedores prediales y
              fortalecer la participación de organizaciones indígenas como
              operadores catastrales. Con el apoyo del Banco Mundial, también se
              busca acelerar la actualización catastral en zonas remotas y
              ambientalmente sensibles, promover el uso local de la información
              territorial y contribuir a la formalización de tierras, la
              gobernanza ambiental y la consolidación de la paz en regiones
              históricamente excluidas.
            </p>
          </div>
        </motion.div>

        {/* Comunidades Geográficas */}
        <div className="mt-20 lg:mt-28 pt-16 lg:pt-20 border-t border-charcoal/15" data-id="element-163">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-12" data-id="element-164">
            <div className="lg:col-span-5" data-id="element-165">
              <span className="block text-clay uppercase tracking-[0.2em] text-xs font-semibold mb-5" data-id="element-166">
                Cerrando el ciclo · 11–14 mayo 2026
              </span>
              <h3 className="text-3xl md:text-4xl lg:text-5xl font-serif text-forest leading-[1.05]" data-id="element-167">
                Comunidades Geográficas: un nuevo paso en la apropiación
                territorial
              </h3>
            </div>
            <div className="lg:col-span-7 lg:pt-3 space-y-5 text-charcoal/80 font-light leading-relaxed" data-id="element-168">
              <p className="text-lg md:text-xl text-charcoal/85" data-id="element-169">
                Cerrando el ciclo de formación de la Escuela Intercultural nacen
                las Comunidades Geográficas, una estrategia participativa del
                IGAC, apoyada por la cooperación alemana y el Banco Mundial, que
                busca fortalecer la cultura catastral y promover el uso de la
                información geográfica y territorial para el desarrollo de los
                territorios.
              </p>
              <p data-id="element-170">
                Reúne a personas que participaron previamente en la Escuela
                Intercultural y que ahora continúan fortaleciendo sus
                capacidades para aplicar la información catastral en procesos de
                planeación, ordenamiento territorial, gestión ambiental,
                adaptación al cambio climático y seguridad jurídica.
              </p>
            </div>
          </div>

          {/* Imagen Comunidades Geográficas */}
          <motion.figure initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} className="relative w-full overflow-hidden mb-12 aspect-[16/9] md:aspect-[21/9]" data-id="element-171">
            <img src="https://cdn.magicpatterns.com/uploads/uvomHhxcF8NJnuNLw2V2RY/IMG_9119.jpg" alt="Jornada de Comunidades Geográficas con líderes y lideresas" className="absolute inset-0 w-full h-full object-cover" data-id="element-172" />
          </motion.figure>

          {/* Herramientas */}
          <div className="mb-12" data-id="element-173">
            <div className="text-xs uppercase tracking-[0.2em] text-charcoal/60 font-semibold mb-5" data-id="element-174">
              Herramientas que profundizan
            </div>
            <div className="flex flex-wrap gap-3" data-id="element-175">
              {CG_TOOLS.map(tool => <span key={tool} className="bg-bone border border-charcoal/10 px-4 py-2 text-sm font-light text-charcoal" data-id="element-176">
                  {tool}
                </span>)}
            </div>
          </div>

          {/* Municipios 2026 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} className="bg-bone p-8 md:p-10" data-id="element-177">
            <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-3 mb-6" data-id="element-178">
              <h4 className="font-serif text-2xl md:text-3xl text-forest leading-tight" data-id="element-179">
                Líderes y lideresas de 9 municipios
              </h4>
              <span className="text-xs uppercase tracking-widest text-charcoal/60 font-medium" data-id="element-180">
                Inicio de implementación · 2026
              </span>
            </div>
            <p className="text-charcoal/80 font-light leading-relaxed text-base md:text-lg mb-8" data-id="element-181">
              Entre el 11 y el 14 de mayo de 2026, se dio inicio a la
              implementación de las Comunidades Geográficas, formando líderes y
              lideresas de 9 municipios (El Dorado, Mapiripán y Vista Hermosa,
              en el Meta; San Juan Nepomuceno, en Bolívar; Toluviejo, en Sucre;
              Mercaderes e Inzá, en el Cauca; Tumaco, en Nariño, y Puerto Rico,
              en el Caquetá; tres de estos municipios son beneficiarios del
              Pilar 1 del Proyecto TEFOS: Vista Hermosa y Mapiripán (Meta) y
              Puerto Rico (Caquetá).
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3" data-id="element-182">
              {CG_MUNICIPALITIES.map(m => <div key={m.name} className={`flex items-center justify-between gap-3 px-4 py-3 border ${m.tefos ? 'border-clay/40 bg-clay/5' : 'border-charcoal/10'}`} data-id="element-183">
                  <div data-id="element-184">
                    <div className="text-charcoal font-medium text-sm" data-id="element-185">
                      {m.name}
                    </div>
                    <div className="text-charcoal/50 text-xs" data-id="element-186">{m.dept}</div>
                  </div>
                  {m.tefos && <span className="text-clay text-[10px] font-bold uppercase tracking-wider flex-none" data-id="element-187">
                      Pilar 1
                    </span>}
                </div>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}